const LIMIT_BORDEDOM = 2;
const LIMIT_COMFORT = 3;
const LIMIT_IDEAL = 4;
const LIMIT_OPTIMAL = 6;
const LIMIT_STRAIN = 8;

export const STRESS_AVERAGE_STYLE = {
  boredom: { left: "7.5%", backgroundColor: "#ff4900", width: "20%" },
  comfort: { left: "27.5%", backgroundColor: "#ffa200", width: "10%" },
  ideal: { left: "37.5%", backgroundColor: "#c0dc46", width: "10%" },
  optimal: { left: "47.5%", backgroundColor: "#0ac467", width: "20%" },
  strain: { left: "67.5%", backgroundColor: "#ffa200", width: "20%" },
  burnout: { left: "87.5%", backgroundColor: "#ff4900", width: "20%" },
};

export const getStressStandard = (average) => {
  if (average < LIMIT_BORDEDOM) return STRESS_AVERAGE_STYLE.boredom;
  else if (average >= LIMIT_BORDEDOM && average < LIMIT_COMFORT)
    return STRESS_AVERAGE_STYLE.comfort;
  else if (average >= LIMIT_COMFORT && average < LIMIT_IDEAL)
    return STRESS_AVERAGE_STYLE.ideal;
  else if (average >= LIMIT_IDEAL && average < LIMIT_OPTIMAL)
    return STRESS_AVERAGE_STYLE.optimal;
  else if (average >= LIMIT_OPTIMAL && average < LIMIT_STRAIN)
    return STRESS_AVERAGE_STYLE.strain;
  else return STRESS_AVERAGE_STYLE.burnout;
};

export const getStressClassname = (average) => {
  if (average < LIMIT_BORDEDOM) return "boredom";
  else if (average >= LIMIT_BORDEDOM && average < LIMIT_COMFORT)
    return "comfort";
  else if (average >= LIMIT_COMFORT && average < LIMIT_IDEAL) return "ideal";
  else if (average >= LIMIT_IDEAL && average < LIMIT_OPTIMAL) return "optimal";
  else if (average >= LIMIT_OPTIMAL && average < LIMIT_STRAIN) return "strain";
  else return "burnout";
};
